import styled from 'styled-components';
import color from '../utils/style/color';
import { fontSize, fontWeight } from '../utils/style/font';

const SignInButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  font-size: ${fontSize.l}px;
  font-weight: ${fontWeight.bold};
  color: ${color.gray.xxDark};
  vertical-align: middle;
  border-radius: 2px;
  box-shadow: 0 1px 1px 0 rgba(221, 221, 221, 0.5);
  border: solid 1px ${color.gray.xxBright};
  background-color: ${color.gray.xxxxBright};
  &:hover {
    cursor: pointer;
  }
`;

export default SignInButton;
